import DesktopIcon from "../components/icons/DesktopIcon";
import CertificateRoundedIcon from "../components/icons/CertificateRoundedIcon";
import PersonInCircleIcon from "../components/icons/PersonInCircleIcon";
import RefreshIcon from "../components/icons/RefreshIcon";
import AttachmentIcon from "../components/icons/AttachmentIcon";
import LockedFolderIcon from "../components/icons/LockedFolderIcon";
import CertificateWithShieldIcon from "../components/icons/CertificateWithShieldIcon";
import CertificateWithCopyrightsIcon from "../components/icons/CertificateWithCopyrightsIcon";
import HeadsetIcon from "../components/icons/HeadsetIcon";

export const CUSTOM_PLAN = 'enterprise';

export const smallCompaniesBenefitsList = [
  "مثالي للفرق الصغيرة (5–20 موظف)",
  "وصول لمكتبة تدرب (1400+ دورة)",
  "منصة LMS مخصصة بالعلامة التجارية",
  "دعم فني أساسي",
  "مرونة في المشاهدة في أي وقت وبأي مكان",
  "مشاهدة ورش تدريبية مسجلة",
];

export const organizationsBenefitsList = [
  "عدد مقاعد مرن (20+)",
  "جميع مزايا الفرق +",
  "تقارير متقدمة عن الموظفين",
  "مسؤول حساب خاص (Training Success Manager)",
  "إمكانية إنتاج دورات مخصصة حسب القطاع",
  "دعم التحول الرقمي (تسجيل وبث ورش العمل الداخلية)",
];

export const WHY_TO_JOIN_LIST_ITEMS = [
  {
    id: "1",
    Icon: DesktopIcon,
    title: "مكتبة شاملة للدورات",
    subTitle:
      "تعلم مع أكثر من 1150+ دورة تدريبية في مختلف المجالات ناطقة باللغة العربية، لك باشتراك واحد فقط",
  },
  {
    id: "2",
    Icon: CertificateRoundedIcon,
    title: "عدد لا نهائي من شهادات الدورات",
    subTitle:
      "أحصل على شهادة إتمام للدورة التدريبية فور الانتهاء منها، مئات من الشهادات التعليمية بانتظارك.",
  },
  {
    id: "3",
    Icon: PersonInCircleIcon,
    title: "التعلم من خبرات أكبر المدربين بالخليج",
    subTitle:
      "جميع الدورات مستخلصة من خبرات كبار المدربين في الخليج والوطن العربي، مما يتيح لك نصائح وتوجيهات من النخبة.",
  },
  {
    id: "4",
    Icon: RefreshIcon,
    title: "محتوى جديد ودعم مستمر.",
    subTitle:
      "المنصة تضيف دورات جديدة شهريًا ودعمًا على مدار الساعة ، مما يساعدك على تحديث معرفتك ومواكبة أحدث الاتجاهات.",
  },
  {
    id: "5",
    Icon: AttachmentIcon,
    title: "مرفقات لسهولة التطبيق",
    subTitle:
      "توفر مرفقات متعددة داخل كل دورة، تهدف إلى تعزيز الفهم وتقديم أدوات عملية لتطبيق المفاهيم النظرية.",
  },
];

export const TADARAB_FOR_BUSINESS_SAFETY_AND_TERMS = [
  {
    id: "1",
    Icon: LockedFolderIcon,
    iconClassName: "icon-safety",
    title: "حماية البيانات",
    subTitle: "نضمن أعلى معايير الأمان والسرية لبياناتك.",
    link: "https://docs.google.com/document/d/1-sFwMrFxB6UakoUqGNn-84cViGXiX7eBaWCRe1aaWqc/edit",
  },
  {
    id: "2",
    Icon: CertificateWithShieldIcon,
    iconClassName: "icon-safety",
    title: "سياسة الخصوصية",
    subTitle: "نلتزم بالحفاظ على خصوصيتك وعدم مشاركة بياناتك.",
    link: "https://docs.google.com/document/d/1N7kbhu4wk-pTOr-IgcsEjFn4Oe_z-nbUfdprkId84hQ/edit",
  },
  {
    id: "3",
    Icon: CertificateWithCopyrightsIcon,
    iconClassName: "icon-safety",
    title: "حقوق النشر",
    subTitle: "جميع الحقوق محفوظة لشركة تدرب",
    link: "https://docs.google.com/document/d/15IOYnt_daBYzESYZxHOrLQ68_O5U-dYmnwGPbeGwh6A/edit",
  },
  {
    id: "4",
    Icon: HeadsetIcon,
    iconClassName: "icon-safety",
    title: "الدعم الفني",
    subTitle: "فريق دعم جاهز لمساعدتك في أي وقت.",
    link: "https://docs.google.com/document/d/1dX_nHGc2dtcy8EHhI51mpoTLfUyudsrctwymqZrXGRY/edit",
  },
];

export const SUCCESS_PARTNERS = [
  { id: "0", name: "المركز الوطني للتعليم الإلكتروني", image: "/success-partners/partner-1.png" },
  { id: "1", name: "الحسبة", image: "/success-partners/partner-2.png" },
  { id: "3", name: "كونا", image: "/success-partners/partner-3.png" },
  { id: "4", name: "oogoo car", image: "/success-partners/partner-4.png" },
  { id: "5", name: "المركز الوطني للتعليم الإلكتروني", image: "/success-partners/partner-5.png" },
  { id: "6", name: "الحسبة", image: "/success-partners/partner-6.png" },
  { id: "7", name: "كونا", image: "/success-partners/partner-7.png" },
  { id: "8", name: "oogoo car", image: "/success-partners/partner-8.png" },
  { id: "9", name: "المركز الوطني للتعليم الإلكتروني", image: "/success-partners/partner-9.png" },
  { id: "10", name: "الحسبة", image: "/success-partners/partner-10.png" },
  { id: "11", name: "الديكور الحي", image: "/success-partners/partner-11.png" },
];

export const MOCK_REVIEW_CAROUSEL_ITEM = {
  id: "review-carousel-item",
  course: {
    title: "ورشة الذكاء الاصطناعي: دليلك الشامل لاحتراف الإنتاجية",
    image:
      "/images/reviews-background.jpg",
    tutor: { name: "م. أحمد بكري الفايد" },
  },
  review: {
    text: "تجربة منصة تدرب للأعمال مثرية ونتمى أن يتم تعاون أكبر في برامج الذكاء الاصطناعي وبرامج الشهادات الاحترافية المهنية",
    logo: "/success-partners/partner-3.png",
    position: "شركة المنصور المتحدة",
    location: "مدير تطوير الأعمال",
  },
};

export const COUNTRY_OPTIONS = [
  { name: "Kuwait", value: "+965", label: "kw" },
  { name: "Saudi Arabia", value: "+966", label: "sa" },
  { name: "Egypt", value: "+20", label: "eg" },
  // { name: "Qatar", value: "+974", label: "qa" },
  // { name: "Afghanistan", value: "+93", label: "af" },
  // { name: "Aland Islands", value: "+358", label: "ax" },
  // { name: "Albania", value: "+355", label: "al" },
  // { name: "Algeria", value: "+213", label: "dz" },
  // { name: "AmericanSamoa", value: "+1684", label: "as" },
  // { name: "Andorra", value: "+376", label: "ad" },
  // { name: "Angola", value: "+244", label: "ao" },
  // { name: "Anguilla", value: "+1264", label: "ai" },
  // { name: "Antarctica", value: "+672", label: "aq" },
  // { name: "Antigua and Barbuda", value: "+1268", label: "ag" },
  // { name: "Argentina", value: "+54", label: "ar" },
  // { name: "Armenia", value: "+374", label: "am" },
  // { name: "Aruba", value: "+297", label: "aw" },
  // { name: "Australia", value: "+61", label: "au" },
  // { name: "Austria", value: "+43", label: "at" },
  // { name: "Azerbaijan", value: "+994", label: "az" },
  // { name: "Bahamas", value: "+1242", label: "bs" },
  // { name: "Bahrain", value: "+973", label: "bh" },
  // { name: "Bangladesh", value: "+880", label: "bd" },
  // { name: "Barbados", value: "+1246", label: "bb" },
  // { name: "Belarus", value: "+375", label: "by" },
  // { name: "Belgium", value: "+32", label: "be" },
  // { name: "Belize", value: "+501", label: "bz" },
  // { name: "Benin", value: "+229", label: "bj" },
  // { name: "Bermuda", value: "+1441", label: "bm" },
  // { name: "Bhutan", value: "+975", label: "bt" },
  // { name: "Bolivia, Plurinational State of", value: "+591", label: "bo" },
  // { name: "Bosnia and Herzegovina", value: "+387", label: "ba" },
  // { name: "Botswana", value: "+267", label: "bw" },
  // { name: "Brazil", value: "+55", label: "br" },
  // { name: "British Indian Ocean Territory", value: "+246", label: "io" },
  // { name: "Brunei Darussalam", value: "+673", label: "bn" },
  // { name: "Bulgaria", value: "+359", label: "bg" },
  // { name: "Burkina Faso", value: "+226", label: "bf" },
  // { name: "Burundi", value: "+257", label: "bi" },
  // { name: "Cambodia", value: "+855", label: "kh" },
  // { name: "Cameroon", value: "+237", label: "cm" },
  // { name: "Canada", value: "+1", label: "ca" },
  // { name: "Cape Verde", value: "+238", label: "cv" },
  // { name: "Cayman Islands", value: "+ 345", label: "ky" },
  // { name: "Central African Republic", value: "+236", label: "cf" },
  // { name: "Chad", value: "+235", label: "td" },
  // { name: "Chile", value: "+56", label: "cl" },
  // { name: "China", value: "+86", label: "cn" },
  // { name: "Christmas Island", value: "+61", label: "cx" },
  // { name: "Cocos (Keeling) Islands", value: "+61", label: "cc" },
  // { name: "Colombia", value: "+57", label: "co" },
  // { name: "Comoros", value: "+269", label: "km" },
  // { name: "Congo", value: "+242", label: "cg" },
  // { name: "Congo, The Democratic Republic of the Congo", value: "+243", label: "cd" },
  // { name: "Cook Islands", value: "+682", label: "ck" },
  // { name: "Costa Rica", value: "+506", label: "cr" },
  // { name: "Cote d'Ivoire", value: "+225", label: "ci" },
  // { name: "Croatia", value: "+385", label: "hr" },
  // { name: "Cuba", value: "+53", label: "cu" },
  // { name: "Cyprus", value: "+357", label: "cy" },
  // { name: "Czech Republic", value: "+420", label: "cz" },
  // { name: "Denmark", value: "+45", label: "dk" },
  // { name: "Djibouti", value: "+253", label: "dj" },
  // { name: "Dominica", value: "+1767", label: "dm" },
  // { name: "Dominican Republic", value: "+1849", label: "do" },
  // { name: "Ecuador", value: "+593", label: "ec" },
  // { name: "El Salvador", value: "+503", label: "sv" },
  // { name: "Equatorial Guinea", value: "+240", label: "gq" },
  // { name: "Eritrea", value: "+291", label: "er" },
  // { name: "Estonia", value: "+372", label: "ee" },
  // { name: "Ethiopia", value: "+251", label: "et" },
  // { name: "Falkland Islands (Malvinas)", value: "+500", label: "fk" },
  // { name: "Faroe Islands", value: "+298", label: "fo" },
  // { name: "Fiji", value: "+679", label: "fj" },
  // { name: "Finland", value: "+358", label: "fi" },
  // { name: "France", value: "+33", label: "fr" },
  // { name: "French Guiana", value: "+594", label: "gf" },
  // { name: "French Polynesia", value: "+689", label: "pf" },
  // { name: "Gabon", value: "+241", label: "ga" },
  // { name: "Gambia", value: "+220", label: "gm" },
  // { name: "Georgia", value: "+995", label: "ge" },
  // { name: "Germany", value: "+49", label: "de" },
  // { name: "Ghana", value: "+233", label: "gh" },
  // { name: "Gibraltar", value: "+350", label: "gi" },
  // { name: "Greece", value: "+30", label: "gr" },
  // { name: "Greenland", value: "+299", label: "gl" },
  // { name: "Grenada", value: "+1473", label: "gd" },
  // { name: "Guadeloupe", value: "+590", label: "gp" },
  // { name: "Guam", value: "+1671", label: "gu" },
  // { name: "Guatemala", value: "+502", label: "gt" },
  // { name: "Guernsey", value: "+44", label: "gg" },
  // { name: "Guinea", value: "+224", label: "gn" },
  // { name: "Guinea-Bissau", value: "+245", label: "gw" },
  // { name: "Guyana", value: "+595", label: "gy" },
  // { name: "Haiti", value: "+509", label: "ht" },
  // { name: "Holy See (Vatican City State)", value: "+379", label: "va" },
  // { name: "Honduras", value: "+504", label: "hn" },
  // { name: "Hong Kong", value: "+852", label: "hk" },
  // { name: "Hungary", value: "+36", label: "hu" },
  // { name: "Iceland", value: "+354", label: "is" },
  // { name: "India", value: "+91", label: "in" },
  // { name: "Indonesia", value: "+62", label: "id" },
  // { name: "Iran, Islamic Republic of Persian Gulf", value: "+98", label: "ir" },
  // { name: "Iraq", value: "+964", label: "iq" },
  // { name: "Ireland", value: "+353", label: "ie" },
  // { name: "Isle of Man", value: "+44", label: "im" },
  // { name: "Israel", value: "+972", label: "il" },
  // { name: "Italy", value: "+39", label: "it" },
  // { name: "Jamaica", value: "+1876", label: "jm" },
  // { name: "Japan", value: "+81", label: "jp" },
  // { name: "Jersey", value: "+44", label: "je" },
  // { name: "Jordan", value: "+962", label: "jo" },
  // { name: "Kazakhstan", value: "+77", label: "kz" },
  // { name: "Kenya", value: "+254", label: "ke" },
  // { name: "Kiribati", value: "+686", label: "ki" },
  // { name: "Korea, Democratic People's Republic of Korea", value: "+850", label: "kp" },
  // { name: "Korea, Republic of South Korea", value: "+82", label: "kr" },
  // { name: "Kyrgyzstan", value: "+996", label: "kg" },
  // { name: "Laos", value: "+856", label: "la" },
  // { name: "Latvia", value: "+371", label: "lv" },
  // { name: "Lebanon", value: "+961", label: "lb" },
  // { name: "Lesotho", value: "+266", label: "ls" },
  // { name: "Liberia", value: "+231", label: "lr" },
  // { name: "Libyan Arab Jamahiriya", value: "+218", label: "ly" },
  // { name: "Liechtenstein", value: "+423", label: "li" },
  // { name: "Lithuania", value: "+370", label: "lt" },
  // { name: "Luxembourg", value: "+352", label: "lu" },
  // { name: "Macao", value: "+853", label: "mo" },
  // { name: "Macedonia", value: "+389", label: "mk" },
  // { name: "Madagascar", value: "+261", label: "mg" },
  // { name: "Malawi", value: "+265", label: "mw" },
  // { name: "Malaysia", value: "+60", label: "my" },
  // { name: "Maldives", value: "+960", label: "mv" },
  // { name: "Mali", value: "+223", label: "ml" },
  // { name: "Malta", value: "+356", label: "mt" },
  // { name: "Marshall Islands", value: "+692", label: "mh" },
  // { name: "Martinique", value: "+596", label: "mq" },
  // { name: "Mauritania", value: "+222", label: "mr" },
  // { name: "Mauritius", value: "+230", label: "mu" },
  // { name: "Mayotte", value: "+262", label: "yt" },
  // { name: "Mexico", value: "+52", label: "mx" },
  // { name: "Micronesia, Federated States of Micronesia", value: "+691", label: "fm" },
  // { name: "Moldova", value: "+373", label: "md" },
  // { name: "Monaco", value: "+377", label: "mc" },
  // { name: "Mongolia", value: "+976", label: "mn" },
  // { name: "Montenegro", value: "+382", label: "me" },
  // { name: "Montserrat", value: "+1664", label: "ms" },
  // { name: "Morocco", value: "+212", label: "ma" },
  // { name: "Mozambique", value: "+258", label: "mz" },
  // { name: "Myanmar", value: "+95", label: "mm" },
  // { name: "Namibia", value: "+264", label: "na" },
  // { name: "Nauru", value: "+674", label: "nr" },
  // { name: "Nepal", value: "+977", label: "np" },
  // { name: "Netherlands", value: "+31", label: "nl" },
  // { name: "Netherlands Antilles", value: "+599", label: "an" },
  // { name: "New Caledonia", value: "+687", label: "nc" },
  // { name: "New Zealand", value: "+64", label: "nz" },
  // { name: "Nicaragua", value: "+505", label: "ni" },
  // { name: "Niger", value: "+227", label: "ne" },
  // { name: "Nigeria", value: "+234", label: "ng" },
  // { name: "Niue", value: "+683", label: "nu" },
  // { name: "Norfolk Island", value: "+672", label: "nf" },
  // { name: "Northern Mariana Islands", value: "+1670", label: "mp" },
  // { name: "Norway", value: "+47", label: "no" },
  // { name: "Oman", value: "+968", label: "om" },
  // { name: "Pakistan", value: "+92", label: "pk" },
  // { name: "Palau", value: "+680", label: "pw" },
  // { name: "Palestinian Territory, Occupied", value: "+970", label: "ps" },
  // { name: "Panama", value: "+507", label: "pa" },
  // { name: "Papua New Guinea", value: "+675", label: "pg" },
  // { name: "Paraguay", value: "+595", label: "py" },
  // { name: "Peru", value: "+51", label: "pe" },
  // { name: "Philippines", value: "+63", label: "ph" },
  // { name: "Pitcairn", value: "+872", label: "pn" },
  // { name: "Poland", value: "+48", label: "pl" },
  // { name: "Portugal", value: "+351", label: "pt" },
  // { name: "Puerto Rico", value: "+1939", label: "pr" },
  // { name: "Romania", value: "+40", label: "ro" },
  // { name: "Russia", value: "+7", label: "ru" },
  // { name: "Rwanda", value: "+250", label: "rw" },
  // { name: "Reunion", value: "+262", label: "re" },
  // { name: "Saint Barthelemy", value: "+590", label: "bl" },
  // { name: "Saint Helena, Ascension and Tristan Da Cunha", value: "+290", label: "sh" },
  // { name: "Saint Kitts and Nevis", value: "+1869", label: "kn" },
  // { name: "Saint Lucia", value: "+1758", label: "lc" },
  // { name: "Saint Martin", value: "+590", label: "mf" },
  // { name: "Saint Pierre and Miquelon", value: "+508", label: "pm" },
  // { name: "Saint Vincent and the Grenadines", value: "+1784", label: "vc" },
  // { name: "Samoa", value: "+685", label: "ws" },
  // { name: "San Marino", value: "+378", label: "sm" },
  // { name: "Sao Tome and Principe", value: "+239", label: "st" },
  // { name: "Senegal", value: "+221", label: "sn" },
  // { name: "Serbia", value: "+381", label: "rs" },
  // { name: "Seychelles", value: "+248", label: "sc" },
  // { name: "Sierra Leone", value: "+232", label: "sl" },
  // { name: "Singapore", value: "+65", label: "sg" },
  // { name: "Slovakia", value: "+421", label: "sk" },
  // { name: "Slovenia", value: "+386", label: "si" },
  // { name: "Solomon Islands", value: "+677", label: "sb" },
  // { name: "Somalia", value: "+252", label: "so" },
  // { name: "South Africa", value: "+27", label: "za" },
  // { name: "South Sudan", value: "+211", label: "ss" },
  // { name: "South Georgia and the South Sandwich Islands", value: "+500", label: "gs" },
  // { name: "Spain", value: "+34", label: "es" },
  // { name: "Sri Lanka", value: "+94", label: "lk" },
  // { name: "Sudan", value: "+249", label: "sd" },
  // { name: "Suriname", value: "+597", label: "sr" },
  // { name: "Svalbard and Jan Mayen", value: "+47", label: "sj" },
  // { name: "Swaziland", value: "+268", label: "sz" },
  // { name: "Sweden", value: "+46", label: "se" },
  // { name: "Switzerland", value: "+41", label: "ch" },
  // { name: "Syrian Arab Republic", value: "+963", label: "sy" },
  // { name: "Taiwan", value: "+886", label: "tw" },
  // { name: "Tajikistan", value: "+992", label: "tj" },
  // { name: "Tanzania, United Republic of Tanzania", value: "+255", label: "tz" },
  // { name: "Thailand", value: "+66", label: "th" },
  // { name: "Timor-Leste", value: "+670", label: "tl" },
  // { name: "Togo", value: "+228", label: "tg" },
  // { name: "Tokelau", value: "+690", label: "tk" },
  // { name: "Tonga", value: "+676", label: "to" },
  // { name: "Trinidad and Tobago", value: "+1868", label: "tt" },
  // { name: "Tunisia", value: "+216", label: "tn" },
  // { name: "Turkey", value: "+90", label: "tr" },
  // { name: "Turkmenistan", value: "+993", label: "tm" },
  // { name: "Turks and Caicos Islands", value: "+1649", label: "tc" },
  // { name: "Tuvalu", value: "+688", label: "tv" },
  // { name: "Uganda", value: "+256", label: "ug" },
  // { name: "Ukraine", value: "+380", label: "ua" },
  { name: "United Arab Emirates", value: "+971", label: "ae" },
  // { name: "United Kingdom", value: "+44", label: "gb" },
  // { name: "United States", value: "+1", label: "us" },
  // { name: "Uruguay", value: "+598", label: "uy" },
  // { name: "Uzbekistan", value: "+998", label: "uz" },
  // { name: "Vanuatu", value: "+678", label: "vu" },
  // { name: "Venezuela, Bolivarian Republic of Venezuela", value: "+58", label: "ve" },
  // { name: "Vietnam", value: "+84", label: "vn" },
  // { name: "Virgin Islands, British", value: "+1284", label: "vg" },
  // { name: "Virgin Islands, U.S.", value: "+1340", label: "vi" },
  // { name: "Wallis and Futuna", value: "+681", label: "wf" },
  // { name: "Yemen", value: "+967", label: "ye" },
  // { name: "Zambia", value: "+260", label: "zm" },
  // { name: "Zimbabwe", value: "+263", label: "zw" },
];

export const TIMEZONES = [
  'Asia/Kuwait',
  'Asia/Riyadh',
  'Africa/Cairo',
  'Asia/Dubai'
];

export const COUNTRY_TIMEZONE_MAP = {
  KW: 'Asia/Kuwait',
  SA: 'Asia/Riyadh',
  EG: 'Africa/Cairo',
  AE: 'Asia/Dubai',
};